import { Flex, Text } from '@mantine/core';
import dayjs from 'dayjs';

type VacancyHeaderProps = {
  id: number;
  createdAt: string;
  updatedAt: string;
};

export const VacancyHeader = ({
  id,
  createdAt,
  updatedAt,
}: VacancyHeaderProps) => {
  return (
    <Flex align='center' w='100%' justify='space-between' wrap='wrap'>
      <Flex wrap='wrap' rowGap={16} columnGap={32} align='center'>
        <Flex gap={8}>
          <Text size='sm' c='tertiary.7'>
            ID:
          </Text>
          <Text size='sm' c='primary.7'>
            {id}
          </Text>
        </Flex>

        <Flex gap={8}>
          <Text size='sm' c='tertiary.7'>
            Дата создания:
          </Text>
          <Text size='sm' c='primary.7'>
            {dayjs(createdAt).format('DD.MM.YYYY, HH:mm')}
          </Text>
        </Flex>

        <Flex gap={8}>
          <Text size='sm' c='tertiary.7'>
            Дата изменения:
          </Text>
          <Text size='sm' c='primary.7'>
            {dayjs(updatedAt).format('DD.MM.YYYY, HH:mm')}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
